import React from "react";

/**
 * Official WhatsApp glyph (monochrome — inherits `currentColor`).
 * Single-path SVG, ~1.2 KB. Matches Meta's 2021 brand mark (phone + bubble).
 * Usage: <WhatsAppIcon size={18} className="text-emerald-300" />
 */
export default function WhatsAppIcon({ size = 18, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M16.004 3.2C8.94 3.2 3.2 8.94 3.2 16.004c0 2.26.597 4.466 1.733 6.41L3.2 28.8l6.54-1.708a12.78 12.78 0 0 0 6.264 1.6h.005c7.062 0 12.803-5.74 12.803-12.803S23.066 3.2 16.004 3.2zm0 23.334h-.004a10.57 10.57 0 0 1-5.382-1.474l-.385-.23-3.881 1.014 1.036-3.782-.252-.4a10.517 10.517 0 0 1-1.611-5.658c.004-5.82 4.738-10.554 10.564-10.554 2.82 0 5.47 1.1 7.464 3.093a10.48 10.48 0 0 1 3.088 7.468c-.003 5.82-4.738 10.523-10.637 10.523zm5.797-7.895c-.318-.16-1.88-.928-2.172-1.034-.29-.106-.503-.16-.715.16-.21.318-.82 1.034-1.005 1.247-.185.213-.37.24-.687.08-.318-.16-1.342-.494-2.557-1.577-.945-.843-1.582-1.884-1.767-2.202-.185-.318-.02-.49.14-.65.144-.143.317-.37.476-.556.16-.186.213-.318.318-.53.106-.213.053-.398-.027-.557-.08-.16-.715-1.725-.98-2.362-.258-.618-.52-.535-.715-.545-.185-.01-.398-.012-.61-.012-.213 0-.557.08-.848.398-.29.318-1.11 1.086-1.11 2.65 0 1.563 1.138 3.074 1.297 3.286.16.213 2.24 3.42 5.425 4.796.76.328 1.352.523 1.813.67.762.242 1.455.208 2.003.126.611-.092 1.88-.768 2.145-1.51.265-.742.265-1.378.186-1.51-.08-.133-.29-.213-.608-.372z"/>
    </svg>
  );
}
